var map = {
	"./1.png": 6634,
	"./2.png": 37217,
	"./3.png": 99736,
	"./4.png": 48727,
	"./add-button.png": 22149,
	"./assignment.jpg": 61428,
	"./asterisk.png": 69703,
	"./attachment.png": 83860,
	"./audio.png": 71901,
	"./default.png": 11836,
	"./description.png": 63053,
	"./educore-new.png": 4199,
	"./exam.png": 74594,
	"./folder.png": 54055,
	"./g-drive.png": 12811,
	"./google_drive.png": 18323,
	"./hyperlink.png": 51933,
	"./iedu-loader.gif": 95505,
	"./iedu-loader.svg": 35040,
	"./info-slim-yellow.png": 30108,
	"./lesson/actions.png": 52875,
	"./lesson/connections.png": 73741,
	"./lesson/goal.png": 93829,
	"./lesson/hyperlink.png": 56496,
	"./lesson/idea.png": 23993,
	"./lesson/inquiry.png": 12669,
	"./lesson/key-concepts.png": 86129,
	"./lesson/learner-profile.png": 20401,
	"./lesson/learning-approaches.png": 35633,
	"./lesson/lesson-focus.png": 78163,
	"./lesson/line-chart.png": 69921,
	"./lesson/prior-learning.png": 63247,
	"./lesson/related-concepts.png": 63773,
	"./lesson/scope-sequence.png": 77478,
	"./lesson/student-question.png": 69374,
	"./lesson/teacher-question.png": 75499,
	"./login-img.png": 62734,
	"./logo-thumb.png": 96561,
	"./logo.png": 82806,
	"./my_folder.png": 67098,
	"./noimage.png": 78863,
	"./pdf.png": 11577,
	"./pegboard-bg.png": 56819,
	"./person-1.png": 75546,
	"./person-2.png": 35441,
	"./person-3.png": 3400,
	"./person-4.png": 83015,
	"./placeholder150.png": 29584,
	"./question-list-close.png": 85337,
	"./question-list-open.png": 429,
	"./reactions/1.png": 92455,
	"./reactions/2.png": 72396,
	"./reactions/3.png": 41493,
	"./reactions/4.png": 84986,
	"./reactions/default.png": 88433,
	"./report-card-thumb.png": 35209,
	"./signin-google.png": 46121,
	"./signin-microsoft.png": 44198,
	"./sub-1.png": 24759,
	"./sub-2.png": 828,
	"./sub-3.png": 53093,
	"./sub-4.png": 82666,
	"./submit-exam.png": 4895,
	"./thumbs-up.png": 9304,
	"./total-points.png": 153,
	"./trophy.png": 29061,
	"./u-1.png": 83476,
	"./u-2.png": 57967,
	"./u-3.png": 18950,
	"./user-timeline/activity.png": 85566,
	"./user-timeline/agenda.png": 31005,
	"./user-timeline/appointment.png": 12494,
	"./user-timeline/assignment.png": 77030,
	"./user-timeline/attachment-pink.png": 77717,
	"./user-timeline/awards.png": 54575,
	"./user-timeline/calendar-green.png": 70797,
	"./user-timeline/change_password.png": 93861,
	"./user-timeline/check.png": 35357,
	"./user-timeline/contact.png": 28349,
	"./user-timeline/daily-report.png": 45999,
	"./user-timeline/download.png": 30037,
	"./user-timeline/event.png": 78297,
	"./user-timeline/exam.png": 22380,
	"./user-timeline/fees-pink.png": 8510,
	"./user-timeline/grade.png": 4708,
	"./user-timeline/group-report.png": 4821,
	"./user-timeline/health.png": 85155,
	"./user-timeline/home.png": 55748,
	"./user-timeline/journal.png": 83836,
	"./user-timeline/mail-blue.png": 92099,
	"./user-timeline/messaging.png": 57957,
	"./user-timeline/myclass.png": 38463,
	"./user-timeline/mydocument.png": 27068,
	"./user-timeline/newsletter.png": 31108,
	"./user-timeline/notification.png": 6536,
	"./user-timeline/nurse-2.png": 7063,
	"./user-timeline/online-class.png": 84615,
	"./user-timeline/photos.png": 79546,
	"./user-timeline/policy.png": 2375,
	"./user-timeline/poll.png": 9130,
	"./user-timeline/profile.png": 87534,
	"./user-timeline/retest.png": 99602,
	"./user-timeline/settings.png": 8294,
	"./user-timeline/survey.png": 7919,
	"./user-timeline/trophy.png": 97391,
	"./user-timeline/tutorial.png": 64527,
	"./user-timeline/videos.png": 58265,
	"./user-timeline/warning.png": 45169,
	"./wall-clock-red.png": 51964,
	"./youtube.png": 22616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;